import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ligasdeinteres.css';
import { ligasdeinteres_item } from '../../json/ligasdeinteresitem';

const Ligasdeinteres = ({name, data}) => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <div className='container ligasdeinteres-container container-mh'>
        <div className='row'>
            <div className='col-12'>
                <h1 className='title'>Ligas de Interés</h1>
                <hr className='hr-gob'/>
            </div>
        </div>
        <div className='row'>
            {
                ligasdeinteres_item.map((item, index)=>(
                    <div key={ index } className='col-md-4 col-sm-6 col-12 ligasdeinteres_item'>
                        <Link to={ item.ligasdeinteres_item_url } rel='noopener noreferrer'>{ item.ligasdeinteres_item_nombre }</Link>
                        <hr className='row-separator' />
                    </div>
        
                ))
            }
        </div>
    </div>
  )
}
// Pagina Ligas de Interés
export default Ligasdeinteres